import { Pipe } from '@angular/core';
import { pad, isString } from '../utils/utils';
var PadPipe = (function () {
    function PadPipe() {
    }
    PadPipe.prototype.transform = function (input, length, character) {
        if (length === void 0) { length = 0; }
        if (character === void 0) { character = ' '; }
        if (!isString(input)) {
            return input;
        }
        return pad(input, length, character);
    };
    return PadPipe;
}());
export { PadPipe };
PadPipe.decorators = [
    { type: Pipe, args: [{
                name: 'pad'
            },] },
];
/** @nocollapse */
PadPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=pad.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/pad.pipe.js
// module id = 283
// module chunks = 103